import axios from "axios";
import { endpoint } from "./endpoint";
import { saveAuthData, resetData } from "../features/login/LoginSlice"; // corrected: saveAuthData

export const handleCatchBlock = (error) => {};

async function createRequest({ reqHeaders, params, authToken, storeId }) {
  return axios.create({
    baseURL: endpoint.API_BASE_URL,
    responseType: "json",
    crossdomain: true,
    headers: {
      "Content-Type": reqHeaders?.["Content-Type"] || "application/json",
      Accept: "application/json",
      ...(storeId && { ["tenantId"]: storeId }),
      ...(authToken?.accessToken && {
        Authorization: "Bearer " + authToken.accessToken,
      }),
      ...reqHeaders,
    },
    params,
  });
}

export async function apiHandler({
  url,
  method,
  headers: reqHeaders,
  data: jsonData,
  params,
  authToken,
  navigate,
  refreshToken,
  dispatch,
  urls,
  storeId,
}) {
  try {
    const request = await createRequest({
      reqHeaders,
      params,
      authToken,
      storeId,
    });

    let result;

    switch (method) {
      case "POST":
        result = await request.post(url, jsonData);
        break;
      case "PUT":
        result = await request.put(url, jsonData);
        break;
      case "PATCH":
        result = await request.patch(url, jsonData);
        break;
      case "DELETE":
        result = await request.delete(url);
        break;
      default:
        result = await request.get(url);
    }

    const { data, headers, status } = result;
    return { data, headers, status };
  } catch (error) {
    handleCatchBlock(error);

    if (error.status === 401 && authToken?.refreshToken) {
      try {
        const refreshResponse = await apiHandler({
          url: urls?.APPLICATION_URL + endpoint.REFRESH_TOKEN,
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken.refreshToken}`,
          },
          authToken: null,
          dispatch,
          urls,
          storeId,
        });

        if (
          refreshResponse.status === 201 &&
          refreshResponse.data.response.accessToken
        ) {
          const newTokens = refreshResponse.data.response;

          dispatch(
            saveAuthData({
              accessToken: newTokens.accessToken,
              refreshToken: authToken.refreshToken,
            })
          );

          return apiHandler({
            url,
            method,
            headers: reqHeaders,
            data: jsonData,
            params,
            authToken: {
              accessToken: newTokens.accessToken,
              refreshToken: authToken.refreshToken,
            },
            navigate,
            refreshToken,
            dispatch,
            urls,
          });
        } else {
          dispatch(resetData());
        }
      } catch (refreshError) {
        dispatch(resetData());
        navigate("/", { replace: true });

        return {
          data: {
            error_code: 401,
            error_message: "Session expired. Please log in again.",
          },
          headers: {},
          status: 401,
        };
      }
    }

    // Handle 404 status code
    if (error.response?.status === 404) {
      return {
        data: error.response.data,
        status: 404,
      };
    }

    return {
      data: error,
    };
  }
}
